// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ArrowUpIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ArrowUpIcon" ref={forwardedRef} {...props}>
      <path d="m10.01 2.75 6.01 6.01-1.06 1.062-4.2-4.199V17.25h-1.5V5.62L5.057 9.818 4 8.76z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ArrowUpIcon = /* @__PURE__ */ Object.assign(ArrowUpIconComponent, {
  displayName: 'ArrowUpIcon',
});
